
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const WeAreHiring = () => {
  const roles = [
    "Graphic Designers",
    "Video Editors",
    "Content Creators"
  ];

  return (
    <section className="py-16 px-6 bg-gradient-to-r from-blue-50 to-blue-100">
      <div className="container mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="glass-card rounded-xl overflow-hidden shadow-xl"
        >
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-10 text-white">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-4">We Are Hiring!</h2>
                <p className="text-xl text-blue-100 mb-6 md:mb-0">Join our creative team and be part of something amazing</p>
              </div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link 
                  to="/about#careers" 
                  className="inline-block px-8 py-3 bg-white text-blue-600 font-bold rounded-full shadow-lg hover:bg-blue-50 transition-all duration-300"
                >
                  View Openings
                </Link>
              </motion.div>
            </div>
          </div>
          
          <div className="p-6 md:p-8 bg-white">
            <div className="flex flex-col md:flex-row gap-6 justify-between">
              {roles.map((role, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-blue-50 border border-blue-100 rounded-xl p-6 flex-1"
                >
                  <h3 className="text-xl font-bold text-blue-700 mb-2">{role}</h3>
                  <p className="text-gray-600 mb-4">We're looking for talented {role.toLowerCase()} to join our growing team.</p>
                  <Link 
                    to="/about#careers" 
                    className="text-blue-600 font-medium hover:text-blue-800 flex items-center"
                  >
                    Learn more
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WeAreHiring;
